import { Pipe, PipeTransform } from '@angular/core';

/** Takes post content and returns reading time in minutes */
@Pipe({
  name: 'readtime',
  standalone: false,
})
export class ReadTimePipe implements PipeTransform {
  transform(value: string) {
    let readingTimeMinutes = 1;

    if (value !== '') {
      const totalWords = value.trim().split(/\s+/g).length;
      const wordsPerSecond = 180 / 60;
      const totalReadingTimeSeconds = totalWords / wordsPerSecond;

      readingTimeMinutes = Math.floor(totalReadingTimeSeconds / 60);

      if (readingTimeMinutes >= 1) {
        return readingTimeMinutes;
      } else {
        return '< 1';
      }
    } else {
      return readingTimeMinutes;
    }
  }
}
